// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"ErrorMessage_ErrorMessage__hBJLx","ErrorMessage__small":"ErrorMessage_ErrorMessage__small__lC7O4"};